<div class="container-fluid mt-4" *ngIf="statements">
	<div class="text-center mb-4">
		<a [href]="statementLink" target="_blank" class="btn btn-outline-primary btn-lg">
			<i class="fa fa-file-pdf-o mr-2"></i> View Current Statement (PDF)
		</a>
	</div>
	
	<ng-container *ngIf="!statements.success">
		<h4 class="text-center text-danger">No Statements Found</h4>
	</ng-container>
	
	<ng-container *ngIf="statements.success">
		<!-- Email Form Section -->
		<div class="email-form-wrapper mb-4">
			<div class="email-form-container">
				<!-- Form Fields -->
				<div class="form-fields-row">
					<mat-form-field appearance="outline" class="email-field">
						<mat-label>Email Address</mat-label>
						<input matInput [formControl]="email" [disabled]="sending">
					</mat-form-field>

					<mat-form-field appearance="outline" class="date-field">
						<mat-label>Aging Date</mat-label>
						<input matInput [matDatepicker]="picker" [formControl]="todate" [disabled]="sending">
						<mat-datepicker-toggle matSuffix [for]="picker" [disabled]="sending"></mat-datepicker-toggle>
						<mat-datepicker #picker></mat-datepicker>
					</mat-form-field>

					<button 
						mat-raised-button 
						color="accent" 
						(click)="emailStatement()" 
						[disabled]="sending || loading"
						class="send-btn">
						<mat-icon>send</mat-icon>
						<span>{{ sending ? 'Sending...' : 'Send' }}</span>
					</button>
				</div>
				
				<!-- Loading Spinner -->
				<div class="text-center mb-3" *ngIf="loading">
					<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
						<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
					</svg>
				</div>
				
				<!-- Email Editor -->
				<div class="main-container" *ngIf="!loading && isLayoutReady">
					<div class="editor-container editor-container_classic-editor" #editorContainerElement>
						<div class="editor-container__editor">
							<div #editorElement>
								<ckeditor [formControl]="emailMessage" [editor]="Editor" [config]="ckconfig" [disabled]="sending" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Statement Content -->
		<div class="d-flex justify-content-center">
			<div class="bordered p-4 smallericonsplease statement-content" 
				 #statementContent
				 [innerHTML]="statements.content | safeHtml" 
				 *ngIf="!loading">
			</div>
		</div>
	</ng-container>
</div>